import { render, staticRenderFns } from "./TipoVinculo.vue?vue&type=template&id=3c0d0a68"
import script from "./TipoVinculo.vue?vue&type=script&lang=js"
export * from "./TipoVinculo.vue?vue&type=script&lang=js"
import style0 from "./TipoVinculo.vue?vue&type=style&index=0&id=3c0d0a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports